<template>
  <div class="headers">
    <div class="logo">
      <svg-icon name="信永中和logo@3x备份"></svg-icon>
      <p class="message">
        <span>OCR文字识别</span>
      </p>
    </div>
    <div class="right">
      <div class="user">
        <svg-icon name="形状结合"></svg-icon>
        <p class="account">
          <span>{{ account }}</span>
        </p>
      </div>
      <div class="logout">
        <svg-icon name="形状结合(1)"></svg-icon>
        <p class="logout-message" @click="logout">
          <span>登出</span>
        </p>
      </div>
    </div>
  </div>
</template>

<script>
import { baseUrl } from '../../config/env'
export default {
  name: 'Headers',
  data() {
    return {
      account: '佚名'
    }
  },
  props: {},
  watch: {},
  async created() {
    let response = await this.$http.get(`${baseUrl}/user_info`)
    if (response.err === '0') {
      this.account = response.res.username
    } else {
      window.location.href = `${baseUrl}/cas/login`
    }
  },
  methods: {
    logout() {
      window.location.href = `${baseUrl}/cas/logout`
    }
  }
}
</script>

<style scoped>
.headers {
  min-width: 1366px;
  height: 65px;
  background-color: #3e6495;
}
.logo {
  float: left;
}
.logo .svg-icon {
  float: left;
  margin-left: 21px;
  margin-top: 13px;
  width: 69px;
  height: 45px;
}
.logo .message {
  width: 125px;
  height: 28px;
  float: left;
  margin-top: 19px;
  margin-left: 20px;
}
.logo .message span {
  font-size: 20px;
  font-weight: 600;
  color: rgba(255, 255, 255, 1);
}
.headers .right {
  float: right;
  width: 180px;
  height: 30px;
  margin-top: 18px;
}
.headers .right .user {
  float: left;
}
.headers .right .user .svg-icon {
  height: 16px;
  width: 14px;
  margin-top: 5px;
}
.headers .right .user .account {
  display: inline-block;
  color: #fff;
  width: 44px;
  height: 17px;
  font-size: 12px;
  font-weight: 500;
  margin-left: 8px;
  position: relative;
  top: -3px;
}
.headers .right .logout {
  float: left;
  margin-left: 19px;
  position: relative;
}
.headers .right .logout-message {
  display: inline-block;
  width: 24px;
  height: 17px;
  font-size: 12px;
  font-weight: 500;
  color: rgba(255, 255, 255, 1);
  margin-left: 8px;
  position: absolute;
  top: 5px;
  cursor: pointer;
}
.headers .right .logout .svg-icon {
  width: 15px;
  height: 16px;
  margin-top: 5px;
}
</style>
